// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nspan[data-v-8c54757c] {\n  width: 100%;\n  display: block;\n}\n.dfp-slot[data-v-8c54757c] {\n  display: block !important;\n  margin: 0 auto;\n  text-align: center !important;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
